import { traffic } from "./traffic"; //
// PROPERTY TYPE ICONS
//

import houseandland from "../assets/icons/property-types/houseandland.svg";
import apartment from "../assets/icons/property-types/apartment.svg";
import land from "../assets/icons/property-types/land.svg";
import townhome from "../assets/icons/property-types/townhome.svg";
import houseandland_blank from "../assets/icons/property-types/houseandland_blank.svg";
import apartment_blank from "../assets/icons/property-types/apartment_blank.svg";
import land_blank from "../assets/icons/property-types/land_blank.svg";
import townhome_blank from "../assets/icons/property-types/townhome_blank.svg";
import search from "../assets/icons/property-types/search.svg";
import living from "../assets/icons/property-types/living.svg";
import bedroom from "../assets/icons/property-types/bedrooms.svg";
import bathroom from "../assets/icons/property-types/bathrooms.svg";
import garage from "../assets/icons/property-types/garage.svg"; //
// ATTRIBUTES ICONS
//

import corner_lot from "../assets/icons/attributes/corner_lot.svg";
import standard_lot from "../assets/icons/attributes/standard_lot.svg";
import irregular_lot from "../assets/icons/attributes/irregular_lot.svg";
import water_front from "../assets/icons/attributes/water_front.svg";
import garden_front from "../assets/icons/attributes/garden_front.svg";
import golf_course from "../assets/icons/attributes/golf_course.svg";
import close_to_school from "../assets/icons/attributes/school.svg";
import close_to_child_care from "../assets/icons/attributes/childcare.svg";
import close_to_train_station from "../assets/icons/attributes/trainstation.svg";
import wetlands from "../assets/icons/attributes/wetlands.svg";
import park_front from "../assets/icons/attributes/park_front.svg";
import swimming_pool from "../assets/icons/attributes/swimming_pool.svg";
import gym from "../assets/icons/attributes/gym.svg";
import passeggiata from "../assets/icons/attributes/passeggiata.svg";
import extra_parking from "../assets/icons/attributes/extra_parking.svg";
import dual_key from "../assets/icons/attributes/dualkey.svg";
import terrace from "../assets/icons/attributes/terrace.svg";
import investment from "../assets/icons/attributes/investment.svg";
import balcony from "../assets/icons/attributes/balcony.svg"; //
// Others
//

import reset from "../assets/icons/others/reset.svg";
import arrow from "../assets/icons/others/arrow.svg";
import arrow_orange from "../assets/icons/others/arrow_orange.svg";
import chevron from "../assets/icons/others/chevron.svg";
import floorplan from "../assets/icons/others/floorplan.svg";
import floorplan_black from "../assets/icons/others/floorplan_black.svg";
import marker from "../assets/icons/others/marker.svg";
import marker_orange from "../assets/icons/others/marker_orange.svg";
import download from "../assets/icons/others/download.svg";
import loupe from "../assets/icons/others/loupe.svg";
import email from "../assets/icons/others/email.svg";
import whatsapp from "../assets/icons/others/whatsapp.svg";
import facebook from "../assets/icons/others/facebook.svg";
import close from "../assets/icons/others/close.svg";
import close_grey from "../assets/icons/others/close-grey.svg";
import close_black from "../assets/icons/others/close-black.svg";
import filter from "../assets/icons/others/filter.svg";
import share from "../assets/icons/others/share.svg";
import minus from "../assets/icons/others/minus.svg";
import check from "../assets/icons/others/check.svg";
import trash from "../assets/icons/others/trash.svg";
import house from "../assets/icons/others/house.svg";

var absolutePath = function absolutePath(a) {
  var b = traffic.get("app.url") || "",
      c = b.split("/"),
      d = 2 <= c.length ? c[0] + "//" + c[2] : null;
  return d ? "".concat(d).concat(a) : a;
};

export var icons = {
  //
  // PROPERTY TYPE ICONS
  //
  houseandland: absolutePath(houseandland),
  apartment: absolutePath(apartment),
  land: absolutePath(land),
  townhome: absolutePath(townhome),
  houseandland_blank: absolutePath(houseandland_blank),
  apartment_blank: absolutePath(apartment_blank),
  land_blank: absolutePath(land_blank),
  townhome_blank: absolutePath(townhome_blank),
  search: absolutePath(search),
  living: absolutePath(living),
  bedroom: absolutePath(bedroom),
  bathroom: absolutePath(bathroom),
  garage: absolutePath(garage),
  //
  // ATTRIBUTES ICONS
  //
  corner_lot: absolutePath(corner_lot),
  standard_lot: absolutePath(standard_lot),
  irregular_lot: absolutePath(irregular_lot),
  water_front: absolutePath(water_front),
  garden_front: absolutePath(garden_front),
  golf_course: absolutePath(golf_course),
  close_to_school: absolutePath(close_to_school),
  close_to_child_care: absolutePath(close_to_child_care),
  close_to_train_station: absolutePath(close_to_train_station),
  wetlands: absolutePath(wetlands),
  park_front: absolutePath(park_front),
  swimming_pool: absolutePath(swimming_pool),
  gym: absolutePath(gym),
  passeggiata: absolutePath(passeggiata),
  extra_parking: absolutePath(extra_parking),
  dual_key: absolutePath(dual_key),
  terrace: absolutePath(terrace),
  investment: absolutePath(investment),
  balcony: absolutePath(balcony),
  //
  // Others
  //
  reset: absolutePath(reset),
  chevron: absolutePath(chevron),
  download: absolutePath(download),
  floorplan: absolutePath(floorplan),
  floorplan_black: absolutePath(floorplan_black),
  marker: absolutePath(marker),
  marker_orange: absolutePath(marker_orange),
  arrow: absolutePath(arrow),
  arrow_orange: absolutePath(arrow_orange),
  loupe: absolutePath(loupe),
  email: absolutePath(email),
  whatsapp: absolutePath(whatsapp),
  filter: absolutePath(filter),
  facebook: absolutePath(facebook),
  close: absolutePath(close),
  close_grey: absolutePath(close_grey),
  close_black: absolutePath(close_black),
  share: absolutePath(share),
  minus: absolutePath(minus),
  check: absolutePath(check),
  trash: absolutePath(trash),
  house: absolutePath(house)
};
export default icons;